import { AWSCredentialsAPI } from '@eng-portal/czi-extensions-react';
import { ScmAuthApi } from '@backstage/integration-react';

export interface FulfillmentConfig {
  templateRef: string;
  getValues: (inputs: Record<string, any>, apis: FulfillmentApis) => Promise<Record<string, any>>;
  getSecrets: (apis: FulfillmentApis) => Promise<Record<string, any>>;
}

export interface FulfillmentApis {
  awsCredentials: AWSCredentialsAPI;
  scmAuth: ScmAuthApi;
}

async function getAwsAccountValues(
  inputs: Record<string, any>,
  apis: FulfillmentApis,
): Promise<Record<string, any>> {
  const stsCredentials = await apis.awsCredentials.getSTSCredential('czi-id', ['okta-czi-admin']);
  const awsProfile = await apis.awsCredentials.getProfile('czi-id', ['okta-czi-admin']);
  return {
    ...inputs,
    amazonProfile: {
      credential: {
        accessKeyId: stsCredentials?.AccessKeyId,
        secretAccessKey: stsCredentials?.SecretAccessKey,
        sessionToken: stsCredentials?.SessionToken,
      },
      awsAccount: {
        name: awsProfile.aws_account.name,
        ID: awsProfile.aws_account.id,
      },
    },
    sharedInfraRepoUrl: 'github.com?repo=shared-infra&owner=chanzuckerberg',
  };
}

async function getAwsAccountSecrets(
  apis: FulfillmentApis,
): Promise<Record<string, any>> {
  const { token } = await apis.scmAuth.getCredentials({
    url: 'https://github.com/chanzuckerberg/shared-infra',
    additionalScope: { customScopes: { github: ['workflow'] } },
  });
  return { sharedInfraOauthToken: token };
}

export const FULFILLMENT_CONFIGS: Record<string, FulfillmentConfig> = {
  'aws-account': {
    templateRef: 'template:default/create-new-aws-account',
    getValues: getAwsAccountValues,
    getSecrets: getAwsAccountSecrets,
  },
};
